// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/workflow_error.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3 } from "@bufbuild/protobuf";

/**
 * WorkflowErrorCode defines error codes specific to workflows.
 * These codes help distinguish retriable vs non-retriable errors and provide actionable information
 * to both the reconciler and the frontend.
 *
 * Error code ranges:
 * - 0: Unspecified
 * - 1-999: Reserved for future use
 * - 1000-1999: Environment-related errors
 * - 2000-2999: Execution-related errors
 * - 3000-3999: Resource-related errors
 *
 * @generated from enum gitpod.v1.WorkflowErrorCode
 */
export enum WorkflowErrorCode {
  /**
   * @generated from enum value: WORKFLOW_ERROR_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The environment associated with the action no longer exists.
   * This can happen when the environment is deleted externally (by user, garbage collection, or force delete)
   * while the action is still running.
   *
   * @generated from enum value: WORKFLOW_ERROR_CODE_ENVIRONMENT_NOT_FOUND = 1000;
   */
  ENVIRONMENT_NOT_FOUND = 1000,

  /**
   * The environment has reached a deleted phase and cannot be used.
   *
   * @generated from enum value: WORKFLOW_ERROR_CODE_ENVIRONMENT_DELETED = 1001;
   */
  ENVIRONMENT_DELETED = 1001,

  /**
   * The environment content failed to initialize.
   *
   * @generated from enum value: WORKFLOW_ERROR_CODE_ENVIRONMENT_CONTENT_FAILED = 1002;
   */
  ENVIRONMENT_CONTENT_FAILED = 1002,

  /**
   * The environment content is unavailable.
   *
   * @generated from enum value: WORKFLOW_ERROR_CODE_ENVIRONMENT_CONTENT_UNAVAILABLE = 1003;
   */
  ENVIRONMENT_CONTENT_UNAVAILABLE = 1003,
}
// Retrieve enum metadata with: proto3.getEnumType(WorkflowErrorCode)
proto3.util.setEnumType(WorkflowErrorCode, "gitpod.v1.WorkflowErrorCode", [
  { no: 0, name: "WORKFLOW_ERROR_CODE_UNSPECIFIED" },
  { no: 1000, name: "WORKFLOW_ERROR_CODE_ENVIRONMENT_NOT_FOUND" },
  { no: 1001, name: "WORKFLOW_ERROR_CODE_ENVIRONMENT_DELETED" },
  { no: 1002, name: "WORKFLOW_ERROR_CODE_ENVIRONMENT_CONTENT_FAILED" },
  { no: 1003, name: "WORKFLOW_ERROR_CODE_ENVIRONMENT_CONTENT_UNAVAILABLE" },
]);

/**
 * WorkflowError provides structured error information for workflow failures.
 * This enables the reconciler to make informed retry decisions and the frontend
 * to display actionable error messages.
 *
 * @generated from message gitpod.v1.WorkflowError
 */
export class WorkflowError extends Message<WorkflowError> {
  /**
   * Error code identifying the type of error.
   *
   * @generated from field: gitpod.v1.WorkflowErrorCode code = 1;
   */
  code = WorkflowErrorCode.UNSPECIFIED;

  /**
   * Human-readable error message.
   *
   * @generated from field: string message = 2;
   */
  message = "";

  /**
   * Additional metadata about the error.
   * Common keys include:
   * - environment_id: ID of the environment
   * - task_id: ID of the task
   * - service_id: ID of the service
   * - workflow_id: ID of the workflow
   * - workflow_execution_id: ID of the workflow execution
   *
   * @generated from field: map<string, string> meta = 3;
   */
  meta: { [key: string]: string } = {};

  /**
   * Retry configuration. If not set, the error is considered non-retriable.
   *
   * @generated from field: optional gitpod.v1.WorkflowError.Retry retry = 4;
   */
  retry?: WorkflowError_Retry;

  constructor(data?: PartialMessage<WorkflowError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "enum", T: proto3.getEnumType(WorkflowErrorCode) },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "meta", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 4, name: "retry", kind: "message", T: WorkflowError_Retry, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowError {
    return new WorkflowError().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowError {
    return new WorkflowError().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowError {
    return new WorkflowError().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowError | PlainMessage<WorkflowError> | undefined, b: WorkflowError | PlainMessage<WorkflowError> | undefined): boolean {
    return proto3.util.equals(WorkflowError, a, b);
  }
}

/**
 * Retry configuration for the error.
 *
 * @generated from message gitpod.v1.WorkflowError.Retry
 */
export class WorkflowError_Retry extends Message<WorkflowError_Retry> {
  /**
   * Whether the error is retriable.
   *
   * @generated from field: bool retriable = 1;
   */
  retriable = false;

  /**
   * Suggested duration to wait before retrying.
   * Only meaningful when retriable is true.
   *
   * @generated from field: google.protobuf.Duration retry_after = 2;
   */
  retryAfter?: Duration;

  constructor(data?: PartialMessage<WorkflowError_Retry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WorkflowError.Retry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "retriable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "retry_after", kind: "message", T: Duration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WorkflowError_Retry {
    return new WorkflowError_Retry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WorkflowError_Retry {
    return new WorkflowError_Retry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WorkflowError_Retry {
    return new WorkflowError_Retry().fromJsonString(jsonString, options);
  }

  static equals(a: WorkflowError_Retry | PlainMessage<WorkflowError_Retry> | undefined, b: WorkflowError_Retry | PlainMessage<WorkflowError_Retry> | undefined): boolean {
    return proto3.util.equals(WorkflowError_Retry, a, b);
  }
}

